// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-button[data-v-c8b4e11c]{border-top-right-radius:0;border-bottom-right-radius:0;border-right:none}.dropdown-button[data-v-c8b4e11c]{border-top-left-radius:0;border-bottom-left-radius:0;border-left:1px solid hsla(0,0%,100%,.3)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
